import { useQuery } from "@tanstack/react-query"

import { FINANCE_RETURN_FUNDS_QUERY_KEY } from "@/constants/query"
import { getFinanceReturnById, getFinanceReturns } from "@/http/financeReturnFunds"

import { IRequestParams } from "@/types/api"

export const useFinanceReturnFundsQuery = (params?: IRequestParams) => {
    return useQuery({
        queryFn: () => getFinanceReturns(params || {}),
        queryKey: [FINANCE_RETURN_FUNDS_QUERY_KEY, params],
        retry: false
    })
}

export const useFinanceReturnFundsByIdQuery = (id: number) => {
  return useQuery({
    queryFn: () => getFinanceReturnById(id),
    queryKey: [FINANCE_RETURN_FUNDS_QUERY_KEY, id],
    enabled: id !== 0
  })
}
